<template>
  <content-card title="Ferienübersicht Alle" cardIcon="fas fa-list">
    <template v-slot:body>
      <vacation-table pageSection="VacationOverviewAll" />
    </template>
  </content-card>
</template>
<script lang="ts">
import Vue from 'vue';
import { ContentCard } from 'rey-smartmes-ui';
import VacationTable from '@/components/VacationTable.vue';

export default Vue.extend({
  name: 'vacation-overview-all',
  components: { ContentCard, VacationTable }
});
</script>
